'use strict';
define('global/window', [], function () {
    return window;
});

